export enum EventsName {
  DEFAULT = 'modal',
  GROUP_MODAL = 'group_modal',
  DELETE_GROUP_MODAL = 'delete_group_modal',
  UNBAN_MEMBER_COMMUNITY = 'unban_member_community_modal'
}

export type ModalEvent<T> = T
